<template>
  <MediaPickerField v-model="value" media-type="video" />
</template>

<script>
import MediaPickerField from "%/components/MediaPickerField.vue";
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";

export default {
  name: "DynamicAppVideoInputElement",
  components: {
    MediaPickerField,
  },
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  options: [
    new LayoutWidth(undefined, true),
    new LayoutHeight(undefined, true),
  ],
  hidden: true,
  computed: {
    value: {
      get() {
        return this.valueFromContext;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
